<template>
    <div class="mian">
        <template v-if="visible">
            <div class="modal">
                <div class="content">
                    <template v-if="this.model.ai">
                        <div class="title">
                            <h3>我们会尽快与您联系!</h3>
                            <img src="../assets/icon-close.png" @click="visible = false" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="title">
                            <h3>选择您感兴趣的产品及服务，<br />我们会尽快与您联系!</h3>
                            <img src="../assets/icon-close.png" @click="visible = false" />
                        </div>
                        <div class="checkBox">
                            <div v-for="item in options">
                                <input v-model="selectedOptions" type="checkbox" :value="item" :id="item">
                                <label :for="item">{{ item }}</label>
                            </div>
                        </div>
                    </template>
                    <div class="form">
                        <div>
                            <p>公司名称</p>
                            <input v-model="model.companyName" type="text" placeholder="请输入公司名称" />
                        </div>
                        <div>
                            <p>联系方式</p>
                            <input v-model="model.cellPhone" type="text" placeholder="请输入联系方式" />
                        </div>
                    </div>
                    <div class="btn" @click="submitBtn">立即预约</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "trialModal",
    data() {
        return {
            visible: false,
            model: {},
            options: ['物流项目履约监管', '场站作业协同', '集装箱(车)资产运营管理', '结算、清分自动化', '项目运营统计分析', '物料采购与保供策略支持', '与联运通API集成', '铁运项目效率优化'],
            selectedOptions: []
        }
    },
    methods: {
        show(record) {
            this.model = Object.assign({}, record)
            this.selectedOptions = []
            this.visible = true
            if (this.model.ai) {
                this.selectedOptions = ['AI问数']
            }
        },
        hide() {
            this.visible = false
        },
        submitBtn() {
            if (this.selectedOptions.length < 1) {
                alert("请选择您感兴趣的产品！")
                return
            }
            if (!this.model.companyName) {
                alert("请输入公司名称！")
                return;
            }
            if (!this.model.cellPhone) {
                alert("请输入联系方式！")
                return
            }
            this.model.function = this.selectedOptions.join(',')
            this.$axios({
                method: "post",
                url: "https://api.56links.com/intended/saasIntendedCustomer/add",
                data: this.model,
            }).then(() => {
                alert("提交成功")
                this.hide()
            })
        },
    },
}
</script>

<style scoped>
@media screen and (min-width: 1025px) {
    .modal {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal .content {
        width: 6rem;
        background: #fff;
        border-radius: 0.1rem;
        padding: 0.5rem;
    }

    .modal .content .title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .modal .content .title h3 {
        font-size: 0.26rem;
        color: #091c2e;
        font-weight: bold;
    }

    .modal .content .title img {
        width: 0.18rem;
        cursor: pointer;
    }

    .modal .content .checkBox {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: .2rem;
    }

    .modal .content .checkBox div {
        width: 50%;
        height: 0.5rem;
        display: flex;
        align-items: center;
    }

    .modal .content .checkBox div input {
        transform: scale(1.2);
    }

    .modal .content .checkBox div label {
        font-size: 0.16rem;
        margin-left: 0.1rem;
        cursor: pointer;
    }

    .modal .content .form {
        margin-top: .2rem;
    }

    .modal .content .form div {
        height: 0.6rem;
        display: flex;
        align-items: center;
    }

    .modal .content .form div p {
        font-size: 0.18rem;
        color: #091c2e;
    }

    .modal .content .form div input {
        height: 0.4rem;
        border: 1px solid #d2d2d2;
        flex: 1;
        margin-left: 0.3rem;
        padding: 0 0.2rem;
        font-size: 0.16rem;
        color: #091c2e;
    }

    .modal .content .btn {
        width: 3.2rem;
        line-height: 0.48rem;
        background: #1070ff;
        border-radius: 0.24rem;
        text-align: center;
        color: #fff;
        margin: 0.3rem auto 0;
        font-size: 0.18rem;
        cursor: pointer;
    }
}

@media screen and (max-width: 1024px) {
    .modal {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal .content {
        width: 90%;
        background: #fff;
        border-radius: 0.1rem;
        padding: 0.5rem;
    }

    .modal .content .title {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .modal .content .title h3 {
        font-size: 0.3rem;
        color: #091c2e;
        font-weight: bold;
    }

    .modal .content .title img {
        width: 0.3rem;
        cursor: pointer;
    }

    .modal .content .checkBox {
        margin: 0.2rem 0;
    }

    .modal .content .checkBox div {
        height: 0.8rem;
        display: flex;
        align-items: center;
    }

    .modal .content .checkBox div input {
        transform: scale(1.4);
    }

    .modal .content .checkBox div label {
        font-size: 0.26rem;
        margin-left: 0.2rem;
        cursor: pointer;
    }

    .modal .content .form div {
        height: 1rem;
        display: flex;
        align-items: center;
    }

    .modal .content .form div p {
        font-size: 0.26rem;
        color: #091c2e;
    }

    .modal .content .form div input {
        height: 0.6rem;
        border: 1px solid #d2d2d2;
        flex: 1;
        margin-left: 0.3rem;
        padding: 0 0.2rem;
        font-size: 0.26rem;
        color: #091c2e;
    }

    .modal .content .btn {
        width: 4rem;
        line-height: 0.6rem;
        background: #1070ff;
        border-radius: 0.3rem;
        text-align: center;
        color: #fff;
        margin: 0.3rem auto 0;
        font-size: 0.28rem;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/trialModal.vue